import { makeStyles } from '@material-ui/core'

const styles = (color, width = 158) =>
  makeStyles((theme) => ({
    cell: {
      width,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing(0.5),
    },
    switchBase: {
      '&$checked': {
        color: theme.palette.white,
        '& + $track': {
          backgroundColor: color.main,
          opacity: 1,
        },
      },
    },
    checked: {},
    track: {},
    info: {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.secondary.light,
      cursor: 'default',
    },
  }))

export default styles
